import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Load } from 'src/app/core/types';

@Component({
    selector: 'gl-load-list-element',
    templateUrl: './load-list-element.component.html',
    styleUrls: ['./load-list-element.component.scss'],
    standalone: false
})
export class LoadListElementComponent implements OnInit{
  @Output() public chosen: EventEmitter<Load> = new EventEmitter<Load>();
  @Output() public submitted: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public edit: EventEmitter<Load> = new EventEmitter<Load>();
  @Output() public addLoadEvent: EventEmitter<Load> = new EventEmitter<Load>();
  @Input() public load: Load;
  @Input() public hoverActive: boolean;
  @Input() public isQuick = false;
  @Input() public individualAddBlocked = false;
  public loadQty = 1;
  public isLoadStacked = false;

  @HostListener('click')
  public onClick(): void {
    this.chosen.emit(this.load);
  }

  @HostListener('mouseenter')
  public onMouseEnter(): void {
    if (this.hoverActive) {
      this.chosen.emit(this.load);
    }
  }

  public addLoad(e: MouseEvent): void {
    e.preventDefault();
    e.stopPropagation();
    if (this.individualAddBlocked) {
      return;
    }
    const isStacked: boolean = this.isQuick ? this.isLoadStacked : this.load.stacking;
    const modifiedLoad = {
      ...this.load,
      quantity: this.loadQty === null ? 1 : this.loadQty,
      stacking: isStacked,
      stackingOptions: isStacked
        ? { ...this.load.stackingOptions, stacking: true }
        : {
            pctSupport: this.load.stackingOptions.pctSupport,
            formation: this.load.stackingOptions.formation,
          },
    };
    this.loadQty = 1;
    this.addLoadEvent.emit(modifiedLoad);
  }

  public changeLoadStacking(): void {
    this.isLoadStacked = !this.isLoadStacked;
  }

  public editLoad(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
    this.loadQty = 1;
    this.edit.emit(this.load);
  }

  ngOnInit(): void {
    this.isLoadStacked = this.load.stacking;
  }
}
